export default function redirect({url, token}) {
  const f = document.createElement('form')
  f.action = url
  f.method = 'POST'

  const i = document.createElement('input')
  i.type = 'hidden'
  i.name = 'token_ws'
  i.value = token
  f.appendChild(i)

  document.body.appendChild(f)
  f.submit()
}
